<template>
    <div class="page">
        <div class="main_body">

            <div class="top_label">
                <div class="lable_name">
                    <span>{{detail.task_name}}</span>
                    <span> | </span>
                    <span class="lable_time">{{detail.start_time}} 至 {{detail.end_time}}</span>
                </div>
                <span class="lable_plan_name">{{ plan_name }}</span>
            </div>
            
            <div class="work_top_statitsc">

                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">最高分</span>
                        <div class="work_buttom_statitsc_item_left">
                            <div>
                                <span class="number">{{detail.max_fraction}}</span>
                                <span class="unit">分</span>
                            </div>
                            <span class="high_student_name">{{detail.max_fraction_name}}</span>
                        </div>
                        
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span>
                            <el-icon class="el-icon-s-opportunity"></el-icon>
                        </span>
                    </div>
                </div>
                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">完成人数</span>
                        <div class="work_buttom_statitsc_item_left">
                            <div>
                                <span class="number">{{detail.complete_count}}</span>
                                <span class="unit">人</span>
                            </div>
                        </div>
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span style="color: #9333ea;background: #f3e8ff;">
                            <el-icon class="el-icon-s-custom"></el-icon>
                        </span>
                    </div>
                </div>
                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">平均分</span>
                        <div class="work_buttom_statitsc_item_left">
                            <div>
                                <span class="number">{{detail.total_avg_fraction}}</span>
                                <span class="unit">分</span>
                            </div>
                        </div>
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span style="color: #67C23A;background: #E1F3D8;">
                            <el-icon class="el-icon-s-data"></el-icon>
                        </span>
                    </div>
                </div>
                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">任务完成率</span>
                        <div class="work_buttom_statitsc_item_left">
                            <div>
                                <span class="number">{{detail.complete_rate}}</span>
                                <span class="unit">%</span>
                            </div>
                        </div>
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span style="color: #F56C6C;background: #FDE2E2;">
                            <el-icon class="el-icon-message-solid"></el-icon>
                        </span>
                    </div>
                </div>
                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">做题人数</span>
                        <div class="work_buttom_statitsc_item_left">
                            <div>
                                <span class="number">{{detail.submit_user}}</span>
                                <span class="unit">人</span>
                            </div>
                        </div>
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span style="color: #E6A23C;background: #FAECD8;">
                            <el-icon class="el-icon-s-claim"></el-icon>
                        </span>
                    </div>
                </div>

            </div>
            <div class="Tasklistchart_box">

                <div class="Tasklistchart_box_chart_left">
                    <span class="Tasklistchart_box_title">学生做题统计</span>
                    <Tasklistchart :type="1" :plan_id="work_from.plan_id" :task_id="work_from.task_id"></Tasklistchart>
                </div>
                
                
                <div class="Tasklistchart_box_chart_right">
                    <span class="Tasklistchart_box_title">成绩分布</span>
                    <Taskdetailright :plan_id="work_from.plan_id" :task_id="work_from.task_id"></Taskdetailright>
                </div>
            </div>

            <div v-if="work_from.type == 0" class="work_statistics_box">
                <!-- <div class="work_statistics_title"> 
                    <i class="el-icon-collection"></i>
                    <span>作业内容</span>
                </div> -->
                
                <Timeline :periods_data="periods_data" :periods="work_from.periods" @selectPeriod="handleSelectPeriod"></Timeline>
            </div>

            <div class="student_list_box">
                <div class="student_list_box_title"> 
                    <div class="student_list_box_title_left">
                        <i class="el-icon-collection"></i>
                        <div>作业明细 <span v-if="work_from.type == 0"> (当前第 {{work_from.periods}} 期)</span></div>
                    </div>
                </div>
            </div>

            <div class="task_work_list_box">
                <div v-for="(item,index) in task_work_data" :key="index" class="task_work_list_box_item">
                    <span class="title">{{item.title}}</span>
                    <div class="task_work_list_box_item_text">
                        <span>{{item.type == 0?'阅读在线':'应试英语'}}</span>
                        <span class="el-icon-success"> {{item.do_student_number}}人完成</span>
                    </div>
                </div>
            </div>
            <el-pagination
                style="margin-top:20px"
                background
                layout="prev, pager, next"
                :total="work_count"
                hide-on-single-page
                :current-page="work_from.page"
                :page-size.sync="work_from.pageSize"
                @current-change="handleCurrentChange"
            >
            </el-pagination>


            <div class="student_list_box">
                <div class="student_list_box_title"> 
                    <div class="student_list_box_title_left">
                        <i class="el-icon-collection"></i>
                        <span>学生做题统计</span>
                    </div>
                </div>
            </div>
            <div class="student_task_list">
                <div class="student_task_list_item" v-for="item in work_list" :key="item.id">
                    <div class="student_info_box">
                        <span class="name">{{item.name}}</span>
                        <span class="stuid">{{item.stuid}}</span>
                    </div>
                    <div class="student_task_box">
                        <div class="student_task_box_item">
                            <span class="icon">
                                <i class="el-icon-edit"></i>
                            </span>
                            
                            <div>
                                <span class="number">{{item.complete_count}}</span>
                                <span class="unit">题</span>
                            </div>
                            <span class="student_task_text">完成率题数</span>
                        </div>
                        <div class="student_task_box_item">
                            <span class="icon">
                                <i class="el-icon-s-data"></i>
                            </span>
                            
                            <div>
                                <span class="number">{{item.avg_score}}</span>
                                <span class="unit">%</span>
                            </div>
                            <span class="student_task_text">平均正确率</span>
                        </div>
                        <div class="student_task_box_item">
                            <span style="color: #F56C6C;background: #FDE2E2;" class="icon">
                                <i class="el-icon-s-claim"></i>
                            </span>
                            
                            <div>
                                <span class="number">{{item.total_fraction}}</span>
                                <span class="unit">分</span>
                            </div>
                            <span class="student_task_text">总分数</span>
                        </div>
                    </div>
                    <span @click="dodetail(item)" class="detail_button el-icon-monitor"> 查看详情</span>
                </div>
            </div>

            <el-dialog class="studentDodialog" width="46%" :title="`${student_name} 作业完成情况`" :visible.sync="studentDodialog">
                <el-table
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        prop="title"
                        label="文章标题">
                    </el-table-column>
                    <el-table-column
                        prop="time"
                        label="耗时(秒)"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="score"
                        label="正确率"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="fraction"
                        label="分数"
                        width="100">
                    </el-table-column>

                </el-table>
            
            </el-dialog>
        </div>
    </div>
</template>
<script>

import Timeline from '../../../untils/timeline.vue'
import Taskdetailright from "../../../untils/chart/taskdetailright.vue";
import Tasklistchart from "../../../untils/chart/tasklistchart.vue";
import Http from "../../apis/work";
export default {
    components:{
        Tasklistchart,
        Taskdetailright,
        Timeline
    },
    data() {
        return {
            activeName: 'first',
            dialogFormVisible:false,
            list:[],
            detail:{},
            period_text:'',
            plan_name:'',
            periods_data:[],
            work_count:0,
            task_work_data:[],
            work_list:[],
            studentDodialog:false,
            student_name:'',
            tableData:[],
            work_from:{
                task_id:'',
                plan_id:'',
                periods:0,
                type:0, // 0:周期内作业 1:临时作业
                page:1,
                pageSize:12,
            }
        }
    },
    created() {
        this.work_from.type = this.$route.query.type
        this.work_from.plan_id = this.$route.query.plan_id
        this.plan_name = this.$route.query.plan_name
        this.work_from.task_id = this.$route.query.task_id
        this.geList(this.work_from.plan_id)
        this.workDetailPeriods()
        this.workDetailTopStatistics()
        
    },

    methods: {
        dodetail(item){
            this.student_name = item.name
            var params = {}
            params.task_id = this.work_from.task_id
            params.plan_id = this.work_from.plan_id
            params.uid = item.uid
            params.periods = this.work_from.periods
            Http.studentWorkDo(params).then((res) => {
                this.tableData = res.data
                this.studentDodialog = true
            });
        },

        workDetailTopStatistics(){
            Http.workDetailTopStatistics({task_id: this.work_from.task_id,plan_id: this.work_from.plan_id}).then((res) => {
                this.detail = res.data
            });
        },


        workDetailWorkList(periods){
            Http.workDetailWorkList({task_id: this.work_from.task_id,periods: periods,plan_id: this.work_from.plan_id}).then((res) => {
                this.work_list = res.data
            });
        },
        handleSelectPeriod(item){
       
            this.work_from.periods = item.periods
            this.workDetailWorkList(item.periods)
            this.getWorkDetail(item.periods)
        },
        workDetailPeriods(){
            Http.workDetailPeriods({task_id: this.work_from.task_id,plan_id: this.work_from.plan_id}).then((res) => {
                this.periods_data = res.data.result
                this.work_from.periods = res.data.periods
                this.workDetailWorkList(res.data.periods)
                this.getWorkDetail(res.data.periods)
            });
        },

        // 详情
        viewWorkDetail(){
            this.$refs.cycle.viewWorkDetail(this.work_from.task_id,1,this.work_from.plan_id)
            // if(this.form.type == 0){
            //     this.$refs.cycle.viewWorkDetail(task_id,period_text,this.form.plan_id)
            // }else{
            //     this.$refs.temporary.viewWorkDetail(task_id,this.form.plan_id)
            // }
            
        },
        // 获取周期内作业
        getWorkDetail(periods){
            if(this.work_from.type == 0){
                this.work_from.periods = periods
            }else{
                delete this.work_from.periods
            }
            
            Http.getWorkDetail(this.work_from).then((res) => {
                this.task_work_data = res.data.list
                this.work_count = res.data.count
            });
        },

        // 分页
        handleCurrentChange(val) {
            this.work_from.page = val
            this.getWorkDetail(this.work_from.periods)
        },



        // 导出作业
        importWork(task_id){
            const fileUrl = `${this.$Server.tempHost}/api/teachwork/importWork?token=${window.sessionStorage.getItem("token")}&task_id=${task_id}&plan_id=${this.form.plan_id}`;  

            location.href = fileUrl
        },
        importStudentWork(task_id){
        
            const token = window.sessionStorage.getItem("token");
            const fileUrl = `${this.$Server.tempHost}/api/teachwork/importStudentWork?token=${token}&task_id=${task_id}&plan_id=${this.form.plan_id}`;
            
            // 新开窗口下载
            const downloadWindow = window.open(fileUrl, '_blank');
            
            // 监听窗口关闭/加载完成
            const checkWindow = setInterval(() => {
                if (downloadWindow.closed) {
                clearInterval(checkWindow);
                this.$message.success('下载窗口已关闭');
                } else if (downloadWindow.document.readyState === 'complete') {
                clearInterval(checkWindow);
                // 可以在这里添加下载完成的处理逻辑
                }
            }, 1000);
            
            // 添加下载状态提?
            this.$message.info('正在准备下载文件，请稍后..');
            
        },

        
        geList(){
            const loading = this.$loading({
                lock: true,
                text: '疯狂加载中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            Http.getWork(this.form).then((res) => {
                loading.close()
                this.list = res.data
            });

        },
        delWork_(task_id){
            this.$confirm('删除后不可恢? 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var params = {}
                params.task_id = task_id
                params.plan_id = this.form.plan_id
                Http.delWork(params).then((res) => {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: res.code ? 'success' : 'error'
                    });
                    this.geList()
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '操作已取消'
                });          
            });
            

        },
        handleClick(tab, event) {
            this.form.type = tab.index
            this.geList();
        },
        Cyclework(){
     
            this.$router.push({name:'Cyclework',query:{plan:this.form.plan_id}});
        },

        Temporary(){

            this.$router.push({name:'Temporary',query:{plan:this.form.plan_id}});
        },
    }
};
</script>

<style scoped>

.top_label{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    gap: 10px;
}
.lable_time{
    font-size: 14px;
    color: #000000;
    font-weight: 400;
}
.lable_plan_name{
    font-size: 14px;
    font-weight: 400;
    color: #000000;
}
.work_top_statitsc{
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    margin-top: 20px;
}
.work_top_statitsc_item{
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.work_top_statitsc_item_left{
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 25px;
}

.work_buttom_statitsc_item_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 15px;

}
.work_buttom_statitsc_item_left .unit{
    font-size: 14px;
    margin-left: 3px;
}
.high_student_name{
    color: #f56c6c;
    font-size: 14px;
    margin-top: 4px;
}

.work_top_statitsc_item_left .name{
    font-size: 14px;
    font-weight: 700;
}
.work_top_statitsc_item_left .number{
    font-size: 18px;
    font-weight: 700;
}


.work_top_statitsc_item_right{
    display: flex;
    align-items: center;
}

.work_top_statitsc_item_right span{
    padding: 12px;
    display: flex;
    align-items: center;
    background: #D9ECFF;
    border-radius: 50%;
    color: #409eff;
    font-size: 18px;
}
.Tasklistchart_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.Tasklistchart_box_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
}
.Tasklistchart_box_chart_left{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    width: 100%;

}
.Tasklistchart_box_chart_right{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    width: 400px;
}
.work_statistics_box{
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    border-radius: 8px;
}
.work_statistics_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    font-size: 18px;
}
.student_list_box{
    width: 100%;
    display: inline-block;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-top: 25px;
    background: #fff;
}

.student_list_box_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.student_list_box_title_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 700;
}

.student_list_box_title_right{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
.student_task_list{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: 20px;
}
.student_task_list_item{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    background: #fff;
}
.student_info_box{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    margin-bottom: 10px;
    border-bottom: 1px solid #E4E7ED;
    padding-bottom: 15px;
}
.student_info_box .name{
    font-size: 18px !important;
    font-weight: 700;
    color: #000000;
}
.student_info_box .stuid{
    font-size: 14px;
    opacity: 0.8;
}

.student_task_box{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}
.student_task_box_item{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    background: #F9FAFB;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 8px;
}
.student_task_box_item .number{
    font-size: 20px;
    font-weight: 700;
}
.student_task_box_item .unit{
    font-size: 12px;
    margin-left: 3px;
}
.student_task_text{
    font-size: 12px;
    opacity: 0.7;
}
.student_task_box .icon{
    width: 35px;
    height: 35px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #D9ECFF;
    border-radius: 5px;
    color: #409eff;
    font-size: 18px;
}
.detail_button{
    cursor: pointer;
    background: #409eff;
    color: #ffffff;
    font-size: 12px;
    padding: 7px 15px;
    text-align: center;
    border-radius: 4px;
}
.main_body >>> .el-dialog{
    border-radius: 8px;
    max-height: 80vh;
    overflow-y: auto;
}
.main_body >>> .el-dialog__header{
    text-align: left;
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}

.task_work_list_box{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: 20px;
}

.task_work_list_box_item{
    background: #fff;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
}
.task_work_list_box_item .title{
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    color: #000000;
}
.task_work_list_box_item_text{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 14px;
}
.task_work_list_box_item_text .el-icon-success{
    background: #D9ECFF;
    border-radius: 5px;
    color: #409eff;
    padding: 5px 10px;
    font-size: 12px;
}

</style>